let PaymentType = /*#__PURE__*/function (PaymentType) {
  PaymentType["DIRECT"] = "DIRECT";
  PaymentType["DEFERRED"] = "DEFERRED";
  PaymentType["ONE_TIME"] = "ONE_TIME";
  return PaymentType;
}({});

export { PaymentType };
//# sourceMappingURL=PaymentType.js.map
